import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale, BAND_NAME, SHORT_BAND_NAME, BAND_NAME_JP, SHORT_BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Social from 'components/Social';
import Title from 'components/ui/Title';
import SidebarBox from 'components/ui/SidebarBox';
import Community from 'components/Community';
import ReportErrorContact from "components/ReportErrorContact";

const SideBar = () => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <React.Fragment>
      <SidebarBox>
        <Title element="h2">{intl.formatMessage({ id: 'sidebar.purpose.title' })}</Title>
        <p>
          {intl.formatMessage({ id: 'sidebar.purpose.description' }, {
            slogan: <b>{intl.formatMessage({ id: 'sidebar.purpose.description.slogan' })}</b>,
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
          })}
        </p>
      </SidebarBox>
      <SidebarBox>
        <Title element="h2">
          {intl.formatMessage({ id: 'sidebar.community.title' }, {
            shortBandName: locale === AppLocale.EN ? SHORT_BAND_NAME : SHORT_BAND_NAME_JP
          })}
        </Title>
        <Community />
      </SidebarBox>
      <SidebarBox>
        <Title element="h2">
          {intl.formatMessage({ id: 'sidebar.socials' }, {
            shortBandName: locale === AppLocale.EN ? SHORT_BAND_NAME : SHORT_BAND_NAME_JP
          })}
        </Title>
        <Social />
      </SidebarBox>
      <SidebarBox>
        <Title element="h2">
          {intl.formatMessage({ id: 'about.creator.report' })}
        </Title>
        <ReportErrorContact />
      </SidebarBox>
    </React.Fragment>
  );
};

export default SideBar;
